// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"29274977","894":"b78420c0"}[chunkId] + ".chunk.js");